import { render, staticRenderFns } from "./ReloadAssigner.vue?vue&type=template&id=6b50b1e8&"
import script from "./ReloadAssigner.vue?vue&type=script&lang=js&"
export * from "./ReloadAssigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports